import { MarketLayoutStylesSchema } from './MarketLayout.styles';

export const matchDetailsStyles: MarketLayoutStylesSchema = {
  headerText: {
    flex: '1',
    align: 'center',
    fontSize: '2xs',
    fontWeight: 'bold',
    color: 'alpha.600',
  },

  rowWrapper: {
    px: '4',
    py: '2',
    alignItems: 'center',
    display: 'flex',
    fontSize: 'xs',
    fontWeight: 'bold',
    justifyContent: 'space-between',
    borderColor: 'transparent',
    borderTopWidth: undefined,
    gap: '2',
    pos: 'relative',
    bg: 'beta.100',
    color: 'alpha.600',
    _before: {
      borderColor: 'blackAlpha.400',
      borderBottomWidth: '1px',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      w: 'full',
      left: '0',
      pos: 'absolute',
      top: '-1px',
    },
  },
  rowWrapperFirst: {
    borderTopWidth: '1px',
    bg: 'beta.100',
    color: 'alpha.600',
    _before: {
      display: 'none',
    },
  },
  rowWrapperWithBtn: {
    bg: 'alpha.700',
    borderBottomRadius: 'base',
  },
  tab: {
    bg: 'alpha.300',
    borderBottom: '1px',
    borderColor: 'white',
    color: 'white',
    fontSize: '2xs',
    fontWeight: 'bold',
    _notFirst: { borderLeftWidth: '1px' },
    _selected: {
      bg: 'alpha.500',
      borderBottomColor: 'transparent',
      color: 'white',
    },
  },
};
